import createContext from 'create-react-context';
var RowContext = createContext({});
export default RowContext;